export const isDate = function (date) {
  return date && (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
}